import React from 'react';
import PlanBuilderPage from '../admin/PlanBuilderPage';
import TrainerLayout from '../../components/layout/TrainerLayout';

/**
 * Trainer Plan Builder = mismo motor que el Admin (mismo componente)
 * con TrainerLayout y rutas /trainer/plans/*.
 *
 * El componente PlanBuilderPage acepta props { LayoutComponent, basePath }
 * para evitar duplicar 1.5K lineas.
 */
const TrainerPlanBuilder = () => (
  <PlanBuilderPage
    LayoutComponent={TrainerLayout}
    basePath="/trainer/plans"
  />
);

export default TrainerPlanBuilder;
